import axios from 'axios'
import mainMenuModule from './main-menu'

export default {
  namespaced: true,
  modules: {
    mainMenuModule: mainMenuModule
  },
  state: {
    chartData: null
  },
  mutations: {
    CLEAR_CHART_DATA (state) {
      state.chartData = null
    },
    UPDATE_CHART_DATA (state, chartData) {
      state.chartData = chartData
    }
  },
  actions: {
    clearChartData (context) {
      context.commit('CLEAR_CHART_DATA')
    },
    async loadChartData (context, url) {
      try {
        const response = await axios.get(this.getters.baseURL + url)
        // console.log(response)
        // const response = await axios.get(process.env.VUE_APP_ROOT_API + url)
        // const response = await axios.get(this.state.mainMenuModule.rootAPI + url)
        // if (!response.data.hasOwnProperty('error')) {
        context.commit('UPDATE_CHART_DATA', response.data)
        // }
      } catch (e) {
        console.error(e)
      }
    }
  },
  getters: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/chart.js